import { forwardRef, createElement } from 'react';

const defaultElement = "div";
const Box = forwardRef(function Box(props, ref) {
    const Element = props.as || defaultElement;
    return createElement(Element, Object.assign({ ref: ref }, props, { as: undefined }));
});

export { Box as B };
